import React from 'react';
import { Check } from 'lucide-react';
import type { MissionWithRelations } from '../types/database';

interface MissionStepperProps {
  missions: MissionWithRelations[];
  currentMissionIndex: number;
}

export const MissionStepper: React.FC<MissionStepperProps> = ({
  missions,
  currentMissionIndex
}) => {
  return (
    <div className="flex items-center justify-start gap-8 px-10 pt-4 pb-2">
      <div className="max-w-[1440px] mx-auto w-full">
        <div className="flex items-center gap-4">
          {missions.map((mission, index) => {
            const nbMissions = missions.length;
            const isActive = index === currentMissionIndex;
            const isCompleted = index < currentMissionIndex;
            const isLast = index === nbMissions - 1;

            return (
              <div key={mission.id} className={`flex items-start gap-4 w-1/${nbMissions}`}>
                <div className="flex flex-col items-start gap-3 w-full">
                  <div className="flex items-center w-full gap-4">
                    {isCompleted ? (
                      <div className="min-w-[40px] min-h-[40px] text-neutral-white bg-primary-600 rounded-full items-center justify-center flex">
                        <Check className="text-neutral-white"/>
                      </div>
                    ) : (
                      <>
                      {isActive ? (
                        <div className="inline-block min-w-[40px] min-h-[40px] w-[40px] h-[40px] rounded-full border-2 p-[4px] border-primary-600 bg-neutral-white">
                          <div className="bg-primary-600 w-full h-full rounded-full block"/>
                        </div>
                      ) : (
                          
                        <div className="min-w-[40px] min-h-[40px] bg-blue-200 rounded-full" />
                      )}
                      </>
                    )}
                    {!isLast && (
                      <div className={`w-full h-1 rounded-full overflow-hidden ${isCompleted ? 'bg-primary-600' : 'bg-blue-200'}`}>
                          {isActive && (
                            <div className="h-full w-[60%] rounded-full bg-primary-600" />
                          )}
                      </div>
                    )}
                  </div> 
                  <div className="text-left text-md">
                    <div className={` text-neutral-600 ${isActive ? 'font-bold' : ''}`}>
                      Mission {mission.numeroMission} sur {missions.length}
                    </div>
                    <div className={`font-medium ${isActive ? 'text-primary-600' : 'text-neutral-500'}`}>
                      {mission.nom}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};